import React from "react";
import { StyleSheet, Text, View, Modal, TouchableOpacity } from "react-native";
import Colours from "../utils/Colours";
import CrossIcon from "../icons/CrossIcon";

const ErrorAlertComp = ({
  message,
  onClose,
  onReplaceShowDate,
  onReplaceTableDate,
  showDateActions,
}) => {
  return (
    <View style={styles.modalOverlay}>
      <View style={styles.modalContainer}>
        <CrossIcon height={40} width={40} color={"red"} />
        {/* <Text style={styles.errorTitle}>Error</Text> */}
        <Text style={styles.errorMessage}>{message}</Text>

        {/* ACTION BUTTONS */}

        {showDateActions && (
          <>
            <TouchableOpacity style={styles.secondaryActionButton} onPress={onReplaceTableDate}>
              <Text style={styles.actionButtonText}>Change table use date with show date</Text>
            </TouchableOpacity>

            <TouchableOpacity style={styles.primaryActionButton} onPress={onReplaceShowDate}>
              <Text style={styles.actionButtonText}>Change show date with table use date</Text>
            </TouchableOpacity>
          </>
        )}

        <TouchableOpacity style={styles.closeButton} onPress={onClose}>
          <Text style={styles.closeButtonText}>Close</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default ErrorAlertComp;

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContainer: {
    width: "80%",
    padding: 20,
    backgroundColor: "white",
    borderRadius: 10,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  errorTitle: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#d9534f",
    marginBottom: 10,
  },
  errorMessage: {
    fontSize: 16,
    color: "#333",
    textAlign: "center",
    marginBottom: 20,
    marginTop: 10,
    fontFamily: "Sen-Regular",
  },

  primaryActionButton: {
    backgroundColor: Colours.LIGHTEST,
    paddingVertical: 12,
    paddingHorizontal: 16,
    // borderWidth: 2,
    // borderColor: Colours.PRIMARY,
    borderRadius: 10,
    width: "100%",
    marginBottom: 10,
  },

  secondaryActionButton: {
    backgroundColor: Colours.LIGHTEST,
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 10,
    width: "100%",
    marginBottom: 15,
  },

  actionButtonText: {
    color: Colours.PRIMARY,
    fontSize: 14,
    fontFamily: "Sen-Regular",
    textAlign: "center",
  },

  closeButton: {
    backgroundColor: Colours.PRIMARY,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 10,
  },
  closeButtonText: {
    color: "white",
    fontWeight: "bold",
    fontSize: 15,
    fontFamily: "Sen-Regular",
  },
});
